import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { Col } from "@/components/customComponents";
import { cn } from "@/utils/cn";

export type SummaryCardAccent = "green" | "red" | "blue" | "orange" | "purple";

export interface ISummaryCardProps {
  label: string;
  value: string;
  subtext?: string;
  accent?: SummaryCardAccent;
}

const ACCENT_COLOR_CLASSES: Record<SummaryCardAccent, string> = {
  green: "border-l-green-500",
  red: "border-l-red-500",
  blue: "border-l-blue-500",
  orange: "border-l-orange-500",
  purple: "border-l-purple-500",
};

const SummaryCard = ({ label, value, subtext, accent = "blue" }: ISummaryCardProps) => (
  <Col
    className={cn(
      "min-w-[140px] flex-1 rounded-xl border border-default-200 border-l-4 bg-content1 p-3 shadow-sm dark:border-default-100 dark:bg-content1 sm:min-w-[160px] sm:p-4",
      ACCENT_COLOR_CLASSES[accent],
    )}
  >
    <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-default-500">
      {label}
    </Text>
    <Text variant={TextVariants.HEADING_5_BOLD} className="mt-1">
      {value}
    </Text>
    {subtext && (
      <Text variant={TextVariants.LABEL_XSMALL_REGULAR} className="mt-0.5 text-default-400">
        {subtext}
      </Text>
    )}
  </Col>
);

export default SummaryCard;
